// extracted by mini-css-extract-plugin
export default {"container":"hotelMapLoader-module__container__vhP-6"};